let taskBoardsCache = null;
let taskBoardsPromise = null;

export const getTaskBoardStepsCache = () => taskBoardsCache?.[0]?.Steps || null;

export const loadTaskBoards = () => {
    if (taskBoardsCache)
        return Promise.resolve(taskBoardsCache);

    if (!taskBoardsPromise) {
        taskBoardsPromise = fetch("/umbraco/api/TaskManagerApi/Board")
            .then((response) => response.ok ? response.json() : [])
            .then((boards) => {
                taskBoardsCache = Array.isArray(boards) ? boards : [];
                return taskBoardsCache;
            })
            .catch(() => {
                taskBoardsCache = [];
                return taskBoardsCache;
            });
    }

    return taskBoardsPromise;
};

export const invalidateTaskBoardsCache = () => {
    taskBoardsCache = null;
    taskBoardsPromise = null;
};
